export const saveToken = (token: string) => {
  window.localStorage.setItem("changeraToken", token);
};
export const removeToken = () =>
  window.localStorage.removeItem("changeraToken");
export const getToken = () => window.localStorage.getItem("changeraToken");
